export { default } from './ShippingTrackingTemplate';



// WEBPACK FOOTER //
// ./src/components/order/ShippingTrackingTemplate/index.js